import { formatSort, SortType } from './helpers/sortingHelper';

export interface QueryParametersPaged<T, FT = T> {
  disablePaging?: false | undefined | null;
  pageIndex: number;
  pageSize: number;
  filter?: Partial<FT>;
  orderBy?: SortType<Partial<T>>;
}

export interface QueryParametersNotPaged<T, FT = T> {
  disablePaging: true;
  filter?: Partial<FT>;
  orderBy?: SortType<Partial<T>>;
}

export type QueryParameters<T, FT> = QueryParametersPaged<T, FT> | QueryParametersNotPaged<T, FT>;

export const buildQueryParams = <T, QT = T>(query: QueryParameters<T, QT>) => ({
  ...query.filter,
  pageSize: query.disablePaging ? -1 : (query.pageSize ?? 50),
  pageNumber: query.disablePaging ? -1 : (query.pageIndex ?? 0),
  orderBy: query.orderBy ? formatSort(query.orderBy) : undefined,
  paged: !query.disablePaging,
});
